module.exports = {"510726100":"曲山镇","510726101":"擂鼓镇","510726102":"通口镇","510726103":"永昌镇","510726104":"安昌镇","510726105":"永安镇","510726106":"禹里镇","510726107":"桂溪镇","510726108":"陈家坝镇","510726109":"小坝镇","510726200":"香泉乡","510726203":"贯岭乡","510726205":"漩坪乡","510726206":"白坭乡","510726208":"片口乡","510726209":"开坪乡","510726210":"坝底乡","510726211":"白什乡","510726212":"青片乡","510726213":"都坝乡","510726214":"桃龙藏族乡","510726215":"墩上乡","510726216":"马槽乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510726.json
// module id = 2307
// module chunks = 0